module.exports = __webpack_public_path__ + "img/鞍山钢铁集团@2x.352f7872.png";